const searchInput = document.querySelector('.header-search-form__inner .header-search');
const empty_collection_data = document.querySelector('.emtry_search_collection');

searchInput.addEventListener('input', function() {
    const inputValue = this.value.trim();

    if (inputValue === '') {
        // console.log('Input is blank.');
        empty_collection_data.classList.remove('filled');
        searchInput.classList.add('empty');
    } else {
        // console.log('Input is filled.');
        searchInput.classList.remove('empty');
        empty_collection_data.classList.add('filled');
    }
});